﻿

/*------------------------------------*\
    #SELECT-COMBOBOX
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.selectCombobox = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {
        $(".js-select-combobox").each(function () {
            var width = $(this).data("width");
            var noResultText = $(this).data("no-result-text");

            $(this).select2({
                language: "sv",
                width: "100%"
            });
        });
    };

    // Initialize module
    $(function () {
        priv.init();
    });

})();
